import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component,inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA, MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { PipesModule } from '@shared/pipes/pipes.module';

@Component({
  selector: 'app-prompt-new',
  standalone: true,
  templateUrl: 'prompt-dialog-new.component.html',
  styleUrls: ['./prompt-dialog-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    NgIf,
    MatDialogModule,
    MatButtonModule,
    PipesModule,
  ],
})
export class PromptDialogNewComponent {
  data: {message?: any; buttonNo?: string; buttonYes?: string; showClose?: boolean} = inject(MAT_DIALOG_DATA).data;
  constructor(
    public dialogRef: MatDialogRef<any>,
  ) {}

  close(): void {
    this.dialogRef.close(null);
  }
}
